import {
    assignDynamicRegexValidatorErrorKey,
    getDynamicFieldVuelidateValidationRules,
    VuelidateValidationRules
} from '@/helpers/dynamic/validation';
import {DynamicFieldRegexValidationRule, DynamicFieldValidationRules} from '@/global/types/dynamic';
import {getRegexFromMask} from '@/plugins/maska/tokens';


export default {
    methods: {
        // @ts-ignore
        validator_createDynamicMask(mask) {

            if (!mask) {

                return null;
            }

            // @ts-ignore
            return (value) => {

                if (!value) {

                    return true;
                }

                const masks = Array.isArray(mask) ? mask : [mask];

                return masks.reduce((isValid, mask) => {

                    if (isValid) {

                        return true;
                    }

                    const regex = getRegexFromMask(mask);

                    return regex.test(value);
                }, false);
            }
        },
        // @ts-ignore
        validator_applyDynamicMask(mask, result) {

            if (mask) {

                result.mask = this.validator_createDynamicMask(mask);
            }

            return result;
        },
        validator_createDynamicValidationRules(validation: undefined | DynamicFieldValidationRules, rules: VuelidateValidationRules = {}): VuelidateValidationRules {

            return getDynamicFieldVuelidateValidationRules(validation, rules);
        },
        validator_appendDynamicRegexErrorKey(regex: DynamicFieldRegexValidationRule, index: number): DynamicFieldRegexValidationRule {

            return assignDynamicRegexValidatorErrorKey(regex, index);
        }
    }
}